import { ALL_ACTION, RULE_STATUS_ALL, COMMISSIONABLE_ALL } from './hotel-rule-ui';

export interface HotelRuleSearchCriteria {
  id?: string;
  organization?: string;
  partitionId?: string;
  name?: string;
  active?: boolean;
  pointOfSale?: {
    names: string[];
  };
  destination?: {
    names: string[];
  };
  action?: string;
  commissionable?: boolean;
  enableFullTextSearch?: boolean;
}

export interface HotelRuleSearchCriteriaUi {
  id?: string;
  organization: string;
  name?: string;
  ruleStatus: string;
  actionType: string;
  commissionable: string;
  applicability?: {
    pointOfSale: string[];
    destination: string[];
  };
  enableFullTextSearch?: boolean;
}

export const initialHotelRuleSearchCriteria: HotelRuleSearchCriteriaUi = {
  organization: '',
  ruleStatus: RULE_STATUS_ALL,
  actionType: ALL_ACTION,
  commissionable: COMMISSIONABLE_ALL
};
